import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountSplitResource, ManagementFeesAccountSplitsResource } from 'src/app/client-api.service';
import { AccountSplitService, ManagementFeeAccountSplit } from '../services/account-splits.service';
import { Subscription, combineLatest } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';
import { FileDownloadService } from 'src/app/shared/tcc-ui/file-download.service';
import { NotificationsService } from 'src/app/shared/tcc-ui/notifications';
import { TableColumn } from 'src/app/shared/tcc-ui/tables';
import { covertArrayToFlatFile, CSV_FORMAT } from 'src/app/shared/tcc-ui/flat-file-util';

@Component({
  selector: 'app-management-fee-account-splits-list',
  templateUrl: './management-fee-account-splits-list.component.html',
  styles: [
  ]
})
export class ManagementFeeAccountSplitsListComponent implements OnInit, OnDestroy {

  panalSize: PanelSize = 'large';
  state: 'initializing' | 'loading' | 'ready' | 'saving';

  accountSplits$ = this.accountSplitService.accountSplits$;
  accountSplits: AccountSplitResource[] | undefined;

  allSplits: ManagementFeeAccountSplit[] = [];

  columns: TableColumn<AccountSplitResource>[] | undefined;

  managementFeeAccountSplits$ = this.accountSplitService.ManagementFeeAccountSplits$
  managementFeeAccountSplits: ManagementFeesAccountSplitsResource[] | undefined;

  filteredAccountSplits: AccountSplitResource[] | undefined;
  
  private sub: Subscription | undefined;

  constructor(private accountSplitService: AccountSplitService,
              private activatedRoute: ActivatedRoute,
              private fileDownloadSvc: FileDownloadService,
              private notificationService: NotificationsService,
              private router: Router) {

    this.state = 'initializing';

    this.columns = [
      { title: 'Org Code', name: 'orgCode' },
      { title: 'Account Split Id', name: 'accountSplitid', hidden: true },
      { title: 'Name', name: 'name' },
      { title: 'Type', name: 'type' },          
      { title: 'Org Code', name: 'splitOrgCode' },
      { title: 'Account', name: 'splitaccount' },
      { title: 'Percentage', name: 'splitpercentage' }          
    ];
   }

  ngOnInit(): void {
    this.sub = this.accountSplitService.closeMgntFeesListSubject$.subscribe(() => {
      this.close();
    });

    combineLatest(this.accountSplits$,
                  this.managementFeeAccountSplits$).pipe(
                    tap(([accountSplits, managementFeeAccountSplits]) => {
                      this.allSplits = [];
                      managementFeeAccountSplits.forEach(m => {
                        const split = new ManagementFeeAccountSplit();                        
                        const accountSplit = accountSplits.find(a => a.id === m.accountSplitId);

                        split.orgCode = m.orgCode;
                        split.name = accountSplit?.name!;
                        split.accountSplitid = accountSplit?.id!;
                        split.type = accountSplit?.type!;                      
                        split.splitOrgCode = accountSplit?.orgCode!;
                        split.splitaccount = accountSplit?.account!;
                        split.splitpercentage = accountSplit?.percentage!;    
                        
                        this.allSplits.push(split);                        
                        this.state = 'ready';
                      })
                    })
                  )
                  .subscribe();
  }

  ngOnDestroy(): void {
    
    this.sub!.unsubscribe();
  }

  close() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

  downloadReport() {
    this.state = 'loading';
    this.notificationService.addSuccess('Download triggered!');
    let headers: string[] = [];
    const data: string[][] = [];

    if (this.allSplits!.length > 0) {
      headers = Object.getOwnPropertyNames(this.allSplits![0]);
      headers = headers.filter((g) => g !== 'growthPathInstanceId'); // remove the id header

      for (const growthPathInstanceDownloadResource of this.allSplits!) {
        const growthPathDescripters = Object.getOwnPropertyDescriptors(growthPathInstanceDownloadResource);
        const temp = [];
        for (const header of headers) {          
          temp.push(growthPathDescripters[header].value); // ensures the proper value to the respectful header
        }
        data.push(temp);
      }
      const today = new Date();
      const fileName = 'FP-Management Fees Account Splits-' + today.toISOString().substring(0, 10);;
      this.exportCsvCommon(headers, data, fileName, 'Export');
    }
  }

  rowClicked(event: any){

  }

    /**
   * converts header and rows to csv text, initiates download, and displays notification
   */
    private exportCsvCommon(header: any[] | undefined, rows: any[][] | any[], fileName: string, title: string) {
      const allData = (header && header.length) ? [header, ...rows] : rows;
      const text = covertArrayToFlatFile(allData, CSV_FORMAT);
      this.fileDownloadSvc.startRawDownload(fileName, text, 'text/csv');
      this.state = 'ready';
      alert(`${title} '${fileName}' was created.  If download does not begin, make sure popups are allowed.`);
    }

}

